import { useState, useEffect } from "react";

import recent from "./v9/styles/recent.module.scss";
import container from "./v9/styles/container.module.scss";
import cd from "./v9/styles/cd.module.scss";
import button from "./v9/styles/button.module.scss";
import trans from "./v9/styles/trans.module.scss";
//import header from "./v9/styles/header.module.scss";
import h2 from "./v9/styles/h2.module.scss";
 
import { loaderPostFetch, csAmount } from "./util";
import Notif from "../../components/notif";
import { Outlet, Link, useLoaderData, Form } from "react-router-dom";
import InfoUser from "./info/index";
//`/`; //
const imagePath = `/wp-user/`;

export async function itloader({ params }) {
 const formData = new FormData();
 formData.append("getinstituition", "getinstituition");

 let tok = window.localStorage.getItem("baUid");
 if (tok != null) {
  formData.append("token", tok);
 }

 const res = await loaderPostFetch(`api/users.php`, formData);

 const formData2 = new FormData();
 formData2.append("getstatement2", "getstatement2");
 if (tok != null) {
  formData2.append("token", tok);
 }
 const res2 = await loaderPostFetch(`api/users.php`, formData2);

 const formData3 = new FormData();
 formData3.append("pincheck", "pincheck");
 if (tok != null) {
  formData3.append("token", tok);
 }
 const pincheck = await loaderPostFetch(`api/users.php`, formData3);

 //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
 return { ...params, ...res2, ...res, ...pincheck };
}

export default function DashboardIndex() {
 const [n, sN] = useState({ display: false, type: "success", msg: "" });

 //let r = {};
 const { data, u, transactions, currency, tb, haspin, details } =
  useLoaderData();

 const [disAmount, sDisAmount] = useState();

 const na = () => {
  sN({ display: true, type: "error", msg: "Not Available in your region" });

  setTimeout(() => {
   sN({ display: false, type: "success", msg: `` });
  }, 5000);
 };

 useEffect(() => {
  let y = window.localStorage.getItem("displayAmount");
  sDisAmount(y);
 }, []);
 useEffect(() => {
  if (disAmount) {
   window.localStorage.setItem("displayAmount", disAmount);
  }
 }, [disAmount]);

 useEffect(() => {
  if (typeof haspin != "undefined") {
   if (!haspin) {
    window.location.href = "dashboard/pincreation";
   }
  }
 }, [haspin]);

 return (
  <>
   <Notif display={n?.display} type={n?.type} msg={n?.msg} />
   <>
    {typeof details == "undefined" ? (
     <>
      <div className={container.box0}>
       <div className={container.box}>
        <div className={h2.l2o}>
         <div
          className={h2.ls}
          style={{
           backgroundImage: `url(${imagePath}i/Untitled.png)`, // Set the background image
          }}
         >
          <div className={h2.l1}>
           <div className={h2.left}>Available Balance</div>
           <img src={`${imagePath}i/logo.svg`} />
          </div>
          <div className={h2.l2}>
           <>{`${currency || ""}${
            tb?.current_balance ? csAmount(tb?.current_balance) : "0.00"
           }`}</>
          </div>
          <div className={h2.l3}>
           <div className={h2.left}>
            <div className={h2.header}>Account Number</div>
            <div className={h2.val}>{data?.account_no || "n/a"}</div>
           </div>
           <div className={h2.right}>
            <div className={h2.header}>Account Status</div>
            <div className={h2.val}>{u?.current_plan||'Tier 1'}</div>
           </div>
          </div>
         </div>
        </div>

        <div className={button.container}>
         <Irtem
          photo="i/img.svg"
          title="Send"
          onClick={() => {
           window.location.href = `dashboard/send`;
          }}
         />
         <Irtem
          photo="i/img2.svg"
          title="Receive"
          onClick={() => {
           window.location.href = `dashboard/add-funds/it`;
          }}
         />
         <Irtem photo="i/img3.svg" title="Loan" onClick={na} />
         <Irtem
          photo="i/img4.svg"
          title="Topup"
          onClick={() => {
           window.location.href = `dashboard/add-funds`;
          }}
         />
        </div>

        <div className={cd.container}>
         <Split
          title="Total Credit"
          photo="i/c2.svg"
          credit={u?.total_credit || "0.00"}
         />
         <Split
          title="Total Debit"
          photo="i/d.svg"
          style="debit"
          debit={u?.total_debit || "0.00"}
         />
        </div>

        <div className={recent.container}>
         <div className={recent.header}>Recent Transactions</div>
         <div className={recent.more}></div>
        </div>

        <div className={trans.container}>
         {!transactions || transactions?.length == 0 ? (
          <div className={container.empty}>
           <div className={container.c}>
            <div className={container.h}>No Transaction History</div>
            <div className={container.s}>
             Your recent transaction should appear here contact
             <br /> support for any issues
            </div>
           </div>
          </div>
         ) : (
          <>
           {transactions ? (
            <>
             
             {transactions?.map((n, i) => {
              return <Entry2 data={n} key={i} currency={currency} />;
             })}
            </>
           ) : null}
          </>
         )}

         {/*<Trxitem
      style="credit"
      date="Mon July 11, 2024"
      msg="Credit From Cyber Coues"
      amt="+$1,000.00"
      status="failed"
     />
     <Trxitem
      style="debit"
      date="Mon July 11, 2024"
      msg="Credit From Cyber Coues"
      amt="+$1,000.00"
      status="failed"
     />*/}
        </div>
       </div>
      </div>
     </>
    ) : (
     <InfoUser state={details} />
    )}
   </>
  </>
 );
}

function Split({ title, style, credit, debit, photo }) {
 return (
  <div className={cd.item}>
   <div className={cd.bottom}>
    <div className={cd.bottom1}>
     <div className={cd.header}>{title}</div>
     <div>
      <div className={`${cd[style || "credit"]}`}>
       {credit || ""}
       {debit || ""}
      </div>
     </div>
    </div>
    <div className={cd.img}>
     <img src={`${imagePath}${photo || ""}`} />
    </div>
   </div>
  </div>
 );
}
function Irtem({ photo, title, onClick }) {
 return (
  <div className={button.buttonItem} onClick={onClick}>
   <img src={`${imagePath}${photo || ""}`} />
   <div className={button.txt}>{title || ""}</div>
  </div>
 );
}
function h(n) {
 let y = n.replace("_", " ");
 return y;
}
function Trxitem({ style, date, msg, amt, status, ref2 }) {
 return (
  <div className={trans.itemtrx}>
   <img src={`${imagePath}${style == "credit" ? "i/c3.svg" : "i/d3.svg"}`} />
   <div className={trans.outer}>
    <div className={trans.i1ne}>
     <div className={trans.msg}>{msg}</div>
     <div className={`${trans.amt} ${trans[style || "credit"]} `}>{amt}</div>
    </div>
    <div className={trans.i2wo}>
     <div className={trans.date}>{date}</div>
     <div className={`${trans.status} ${trans[status || "failed"]}`}>
      {h(status || "")}
     </div>
    </div>
   </div>
  </div>
 );
}
function Entry2({ data, currency }) {
 return (
     <Link to={`dashboard/receipt/${data?.ref2}`}>
  <Trxitem
   style={data?.transaction_type}
   date={data?.date}
   msg={data?.name}
   ref2={data?.ref2}
   amt={`${
    data?.transaction_type == "credit" ? `+${currency}` : `-${currency}`
   } ${data?.amount ? csAmount(data?.amount) : "0.00"}`}
   status={data?.status}
  /></Link>
 );
}

export const DashboardR6={
      index: true,
      element: <DashboardIndex />,
      loader: itloader,
    }